import { create } from "zustand";

interface MediaState {
  currentTime: number;
  seekTo: number | null;
  setCurrentTime: (time: number) => void;
  setSeekTo: (time: number | null) => void;
}

export const useMediaStore = create<MediaState>((set) => ({
  currentTime: 0,
  seekTo: null,
  setCurrentTime: (time) => set({ currentTime: time }),
  setSeekTo: (time) => set({ seekTo: time }),
}));
